import { render, staticRenderFns } from "./SampleComponent.vue?vue&type=template&id=0f892854&"
import script from "./SampleComponent.vue?vue&type=script&lang=js&"
export * from "./SampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports